import { render, staticRenderFns } from "./CampaignsNotes.vue?vue&type=template&id=3316eec4&lang=pug"
import script from "./CampaignsNotes.vue?vue&type=script&lang=js"
export * from "./CampaignsNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports